module.exports = __webpack_public_path__ + "img/Retur.c9ea971a.svg";